import { render, staticRenderFns } from "./EzToggle.vue?vue&type=template&id=851f486c&scoped=true&"
import script from "./EzToggle.vue?vue&type=script&lang=js&"
export * from "./EzToggle.vue?vue&type=script&lang=js&"
import style0 from "./EzToggle.vue?vue&type=style&index=0&id=851f486c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851f486c",
  null
  
)

export default component.exports